module.exports = __webpack_public_path__ + "img/single-slide.da132ed.svg";